// services/api.js

const BASE = "https://cbackend.xraidigital.com/api";

export const CAMPS_API = `${BASE}/camps/`;
export const TECH_API = `${BASE}/technician`;

export async function apiFetch(url) {
  const token = localStorage.getItem("token");

  const r = await fetch(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
  });

  if (!r.ok) {
    throw new Error(`HTTP ${r.status}`);
  }

  return r.json();
}

export async function apiPost(url, body) {
  const token = localStorage.getItem("token");

  const r = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
    body: JSON.stringify(body),
  });

  if (!r.ok) {
    throw new Error(`HTTP ${r.status}`);
  }

  return r.json();
}

export async function apiPatch(url, body) {
  const token = localStorage.getItem("token");

  const r = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`,
    },
    body: JSON.stringify(body),
  });

  if (!r.ok) {
    throw new Error(`HTTP ${r.status}`);
  }

  return r.json();
}

export const Loader = ({ text = "Loading..." }) => (
  <div className="loader">
    <div className="spinner" />
    {text}
  </div>
);

export const css = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&family=DM+Mono:wght@400;500&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  :root {
    --bg:       #F4F3EF;
    --surface:  #FFFFFF;
    --border:   #E2E0D8;
    --border2:  #C8C5BB;
    --primary:     #11a8a4;
    --primary-lt:  #e6f6f5;
    --primary-dk:  #0e8f8c;
    --primary-dkr: #0a7673;
    --green:    #1D9E75;
    --green-lt: #EAF3DE;
    --green-dk: #27500A;
    --amber:    #BA7517;
    --amber-lt: #FAEEDA;
    --amber-dk: #633806;
    --red:      #A32D2D;
    --text:     #1A1917;
    --text2:    #6B6860;
    --text3:    #9B9890;
    --radius:   10px;
    --radius-sm:6px;
    --shadow:   0 1px 3px rgba(0,0,0,.07), 0 4px 16px rgba(0,0,0,.05);
  }

  body { font-family: 'DM Sans', sans-serif; background: var(--bg); color: var(--text); -webkit-font-smoothing: antialiased; }

  .app { min-height: 100vh; display: flex; flex-direction: column; }

  /* ── NAV ── */
  .nav {
    display: flex; align-items: stretch;
    background: var(--surface); border-bottom: 1px solid var(--border);
    padding: 0 1.25rem; gap: 0; position: sticky; top: 0; z-index: 100;
    box-shadow: 0 1px 0 var(--border);
  }
  .nav-brand {
    font-size: 14px; font-weight: 600; color: var(--primary-dk);
    display: flex; align-items: center; gap: 7px; padding-right: 20px;
    border-right: 1px solid var(--border); margin-right: 4px;
    letter-spacing: -.3px; white-space: nowrap;
  }
  .nav-brand svg { width: 20px; height: 20px; }
  .nt {
    display: flex; align-items: center; gap: 6px;
    padding: 14px 14px; font-size: 12.5px; font-weight: 500;
    color: var(--text2); border-bottom: 2px solid transparent;
    cursor: pointer; white-space: nowrap; transition: color .15s;
    user-select: none;
  }
  .nt:hover:not(.disabled) { color: var(--text); }
  .nt.active { color: var(--primary); border-bottom-color: var(--primary); }
  .nt.disabled { opacity: .38; pointer-events: none; }
  .nt-badge {
    display: inline-flex; align-items: center; justify-content: center;
    width: 17px; height: 17px; border-radius: 50%;
    background: var(--primary-lt); color: var(--primary-dk);
    font-size: 9.5px; font-weight: 600; font-family: 'DM Mono', monospace;
  }
  .nt.active .nt-badge { background: var(--primary); color: #fff; }

  /* ── PAGE BODY ── */
  .page { flex: 1; padding: 1.5rem 1.25rem; max-width: 860px; margin: 0 auto; width: 100%; }

  /* ── CARDS ── */
  .card {
    background: var(--surface); border: 1px solid var(--border);
    border-radius: var(--radius); padding: 1.1rem 1.25rem; margin-bottom: .85rem;
    box-shadow: var(--shadow);
  }

  /* ── PAGE HEADER ── */
  .ph { font-size: 17px; font-weight: 600; margin-bottom: 1.1rem; display: flex; align-items: center; gap: 8px; letter-spacing: -.3px; }
  .ph-sub { font-size: 13px; color: var(--text2); font-weight: 400; }

  /* ── SECTION LABEL ── */
  .sl { font-size: 10.5px; font-weight: 600; color: var(--text2); text-transform: uppercase; letter-spacing: .07em; margin-bottom: .75rem; display: flex; align-items: center; gap: 6px; }

  /* ── INFO NOTE ── */
  .info-note {
    display: flex; align-items: flex-start; gap: 7px;
    padding: 8px 11px; background: var(--primary-lt); border-radius: var(--radius-sm);
    font-size: 12px; color: var(--primary-dk); margin-bottom: .9rem; line-height: 1.5;
  }

  /* ── CAMP GRID ── */
  .camp-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 1.1rem; }
  .camp-card {
    border: 1.5px solid var(--border); border-radius: var(--radius);
    padding: 1rem; cursor: pointer; transition: border-color .15s, background .15s, box-shadow .15s;
    background: var(--surface);
  }
  .camp-card:hover { border-color: var(--primary); box-shadow: 0 2px 8px rgba(17,168,164,.15); }
  .camp-card.selected { border-color: var(--primary); background: var(--primary-lt); box-shadow: 0 0 0 3px rgba(17,168,164,.1); }
  .camp-top { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 8px; }
  .camp-name { font-size: 14px; font-weight: 600; letter-spacing: -.2px; }
  .camp-meta { font-size: 11.5px; color: var(--text2); margin-top: 3px; display: flex; align-items: center; gap: 4px; }
  .camp-stats { display: flex; gap: 10px; margin-top: 10px; padding-top: 10px; border-top: 1px solid var(--border); flex-wrap: wrap; }
  .cs-item { font-size: 11px; color: var(--text2); display: flex; align-items: center; gap: 3px; }

  /* ── PILLS ── */
  .pill { display: inline-flex; align-items: center; gap: 3px; padding: 3px 8px; border-radius: 20px; font-size: 11px; font-weight: 500; white-space: nowrap; }
  .pill-primary { background: var(--primary-lt); color: var(--primary-dk); }
  .pill-green  { background: var(--green-lt); color: var(--green-dk); }
  .pill-amber  { background: var(--amber-lt); color: var(--amber-dk); }
  .pill-gray   { background: #F1EFE8; color: #444441; }
  .pill-live   { background: var(--primary-lt); color: var(--primary-dk); }
  .pill-live::before { content:''; display:inline-block; width:6px; height:6px; border-radius:50%; background: var(--primary); }

  /* ── AVATAR ── */
  .ava { width: 34px; height: 34px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: 600; flex-shrink: 0; }
  .ava-primary  { background: var(--primary-lt); color: var(--primary-dk); }
  .ava-green { background: var(--green-lt); color: var(--green-dk); }
  .ava-amber { background: var(--amber-lt); color: var(--amber-dk); }

  /* ── TECHNICIAN ROW ── */
  .tech-row {
    display: flex; align-items: flex-start; gap: 10px;
    padding: 11px 12px; border-radius: var(--radius-sm);
    background: #F9F8F5; border: 1px solid var(--border);
    margin-bottom: 8px; transition: background .15s;
  }
  .tech-row:last-child { margin-bottom: 0; }
  .tech-info { flex: 1; min-width: 0; }
  .tech-name { font-size: 13px; font-weight: 600; }
  .tech-meta { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; margin-top: 3px; }
  .svc-chip {
    display: inline-flex; align-items: center; gap: 3px;
    padding: 2px 7px; border-radius: 20px; font-size: 11px;
    background: var(--surface); border: 1px solid var(--border);
    color: var(--text2); margin: 2px 2px 0 0;
  }

  /* ── SWAP AREA ── */
  .swap-area { margin-top: 10px; padding-top: 10px; border-top: 1px solid var(--border); }
  .swap-area label { font-size: 11.5px; color: var(--text2); display: block; margin-bottom: 6px; }
  .swap-select {
    font-size: 13px; padding: 6px 10px; border-radius: var(--radius-sm);
    border: 1px solid var(--border2); background: var(--surface);
    color: var(--text); outline: none; min-width: 180px;
  }
  .swap-select:focus { border-color: var(--primary); box-shadow: 0 0 0 2px rgba(17,168,164,.12); }

  /* ── METRICS GRID ── */
  .met-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; margin-bottom: 1rem; }
  .met { background: #F9F8F5; border: 1px solid var(--border); border-radius: var(--radius-sm); padding: .8rem; text-align: center; }
  .met-v { font-size: 22px; font-weight: 600; font-family: 'DM Mono', monospace; }
  .met-l { font-size: 10.5px; color: var(--text3); margin-top: 2px; }

  /* ── PROGRESS ROW ── */
  .prog-row {
    display: flex; align-items: center; gap: 10px;
    padding: 9px 10px; border-radius: var(--radius-sm);
    background: #F9F8F5; border: 1px solid var(--border);
    margin-bottom: 6px; font-size: 13px; cursor: pointer;
    transition: background .15s;
  }
  .prog-row:hover { background: #F1EFE8; }
  .prog-row:last-child { margin-bottom: 0; }
  .chkbox {
    width: 18px; height: 18px; border-radius: 4px;
    border: 1.5px solid var(--border2); background: var(--surface);
    display: flex; align-items: center; justify-content: center; flex-shrink: 0; transition: all .15s;
  }
  .chkbox.on { background: var(--primary); border-color: var(--primary); }

  /* ── TECH FILTER ── */
  .tech-filter { display: flex; gap: 6px; flex-wrap: wrap; margin-bottom: .9rem; }
  .tf-btn {
    padding: 4px 11px; border-radius: 20px; font-size: 12px; font-weight: 500;
    cursor: pointer; border: 1px solid var(--border); background: var(--surface);
    color: var(--text2); transition: all .15s; font-family: inherit;
  }
  .tf-btn:hover { border-color: var(--primary); color: var(--primary); }
  .tf-btn.active { background: var(--primary); color: #fff; border-color: var(--primary); }

  /* ── SETTLE ── */
  .settle-row { display: flex; justify-content: space-between; padding: 7px 0; border-bottom: 1px solid var(--border); font-size: 13px; }
  .settle-row:last-child { border-bottom: none; }
  .settle-total { font-weight: 600; font-size: 14px; border-top: 1.5px solid var(--border2) !important; border-bottom: none !important; padding-top: 10px !important; margin-top: 4px; }

  /* ── BUTTONS ── */
  .btn {
    display: inline-flex; align-items: center; gap: 5px;
    padding: 7px 14px; border-radius: var(--radius-sm);
    font-size: 13px; font-weight: 500; cursor: pointer;
    border: 1px solid var(--border); background: var(--surface);
    color: var(--text); transition: all .15s; font-family: inherit; white-space: nowrap;
  }
  .btn:hover { background: var(--bg); border-color: var(--border2); }
  .btn-pri { background: var(--primary) !important; color: #fff !important; border-color: var(--primary) !important; }
  .btn-pri:hover { background: var(--primary-dk) !important; border-color: var(--primary-dk) !important; }
  .btn-sm { padding: 5px 10px !important; font-size: 12px !important; }
  .btn-ghost { background: transparent !important; }
  .btn-row { display: flex; justify-content: flex-end; gap: 8px; margin-top: 1rem; }
  .btn-between { display: flex; justify-content: space-between; gap: 8px; margin-top: 1rem; }

  /* ── SPINNER / EMPTY ── */
  .loader { display: flex; align-items: center; justify-content: center; padding: 2rem; gap: 8px; font-size: 13px; color: var(--text2); }
  .spinner { width: 18px; height: 18px; border: 2px solid var(--border); border-top-color: var(--primary); border-radius: 50%; animation: spin .7s linear infinite; }
  @keyframes spin { to { transform: rotate(360deg); } }
  .empty { text-align: center; font-size: 13px; color: var(--text2); padding: 1.5rem; }

  .divider { height: 1px; background: var(--border); margin: .85rem 0; }

  /* ── RESPONSIVE ── */
  @media (max-width: 520px) {
    .camp-grid { grid-template-columns: 1fr; }
    .met-grid { grid-template-columns: repeat(2, 1fr); }
    .nav-brand span { display: none; }
  }
`;

export const paths = {
    mapPin: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",

    users: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z",

    activity: "M13 2.05v2.02c3.95.49 7 3.85 7 7.93 0 3.21-1.81 6-4.72 7.28L13 17v5l5-3-1.22-1.22C19.91 15.93 22 12.11 22 12c0-5.18-3.95-9.45-9-9.95zM11 2.05C5.95 2.55 2 6.82 2 12c0 4.1 2.45 7.86 6.22 9.78L11 22v-5l-2.28 2.28C6.81 18 5 15.21 5 12c0-4.08 3.05-7.44 7-7.93V2.05z",

    receipt: "M19.5 3.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5zM19 19.09H5V4.91h14v14.18zM6 15h12v2H6zm0-4h12v2H6zm0-4h12v2H6z",

    arrowR: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z",
    arrowL: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6z",
    arrows: "M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z",
    check: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z",
    clock: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z",

    info: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z",

    stethoscope: "M19 8C19 5.79 17.21 4 15 4s-4 1.79-4 4v4.5C11 14.43 9.43 16 7.5 16S4 14.43 4 12.5V11H2v1.5C2 15.53 4.47 18 7.5 18s5.5-2.47 5.5-5.5V8c0-1.1.9-2 2-2s2 .9 2 2v1h2V8z",

    dollar: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z",

    refresh: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
};

// ─── ICONS (inline SVG) ───────────────────────────────────────────────────────
export const Icon = ({ n, size = 15 }) => {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" style={{ width: size, height: size, flexShrink: 0 }}>
      <path d={paths[n] || ""} />
    </svg>
  );
};

// ─── HELPERS ─────────────────────────────────────────────────────────────────
export const ini = (name = "") => name.split(" ").slice(0, 2).map(w => w[0] || "").join("").toUpperCase() || "?";
export const avaClass = (idx) => ["ava-primary", "ava-green", "ava-amber"][idx % 3];
export const fmt = (n) => Number(n).toLocaleString("en-IN");